import React from "react";
import PropTypes from "prop-types";
import Svg from "components/elements/svg";

const Checkbox = ({ label, id, name, required, className, ...props }) => (
  <span className={`checkbox${className ? ` ${className}` : ""}`}>
    <input {...props} type="checkbox" id={id || name} name={name} />
    <label htmlFor={id || name}>
      <Svg src="check" className="icon" />
      {label}
      {required && <sup className="required">*</sup>}
    </label>
  </span>
);

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

Checkbox.defaultProps = {
  className: "",
  id: "",
  required: false,
};

export default Checkbox;
